var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Место проведения")]),
              _c("LocationAutocomplete", {
                attrs: {
                  address: _vm.listItem.data.address,
                  loading: _vm.isLoading,
                  "error-messages": _vm.errorMessages.address,
                },
                on: {
                  "set-location": function ($event) {
                    return _vm.mixChangeListItemHandler($event, "address")
                  },
                  "update-location-part": function ($event) {
                    return _vm.mixChangeListItemHandler(
                      $event.value,
                      `address.${$event.fieldName}`
                    )
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("span", [
                _vm._v("Масштаб: "),
                _c("b", [_vm._v(_vm._s(_vm.listItem.data.zoom))]),
              ]),
              _c("v-slider", {
                attrs: {
                  step: "1",
                  "thumb-label": "",
                  ticks: "",
                  min: "1",
                  max: "19",
                  value: _vm.listItem.data.zoom,
                },
                on: {
                  change: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "zoom")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }